/* eslint-disable  */

import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useEmployees, useUpdateEmployee } from '~/employees';
import { useTitle } from '~/titles';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import AssignEmployeeForm from '@/departments/AssignEmployeeForm';
import Form from '@/employees/Form';


const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const TitleEmployees = (props) => {

    //specific department data passed through the url
        const title_id = props.match.params.title_id

    //Title Data
        const { data: title, isLoading } = useTitle(title_id);

    //Bringing title name to header based on the title id
        const title_name = title?.name
        // console.log(title, 'jfwo')

    //Defining Styles
        const classes = useStyles();

    // use useEmployees to get all employees
        const { data: employees, isLoading: employeesisLoading, error } = useEmployees();
        const { mutate: updateEmployee } = useUpdateEmployee();
     
    //list of employees assigned to a specific job title
        const titleEmployees = employees?.filter(employee => employee?.title_id == title_id)
    
    //list of the employees that could be assign in a specific job title
        const notTitleEmployees = employees?.filter(employee => employee?.title_id != title_id)
    
     //handling state changes for the row and actions button      
        const [rowSelected, setRowSelected]=useState();
        const [actions, setActions] = useState(null);

    //Dialog state for "Edit" button
       const [editModalOpen, setEditModalOpen] = useState(false);

    //Dialog state for "Assign" button 
        const [modalOpen, setModalOpen] = useState(false);

    //Handle to open "Assign" dialog
        const handleClickOpen = () => {
            setModalOpen(true);
        }

     // for Edit employee form 
        const [initialValues, setInitialValues] = useState(null);

    // Popover settings.
        const openPopover = (event, row) => {
            // console.log("????", row)
            setRowSelected(row)
            setActions(event.currentTarget);
            };
        const closePopover = () => {
            setActions(null);
            };
        const moreActions = Boolean(actions);

     //Submit
        const onAssignSubmit = (values) => {
            // console.log(values, 'hahaha')

            {
                updateEmployee({
                    id: values.id,
                    payload: {
                        ...values,
                        title: {id: title_id}
                    }
                });
            }
        };

        const onEditSubmit = (values) => {
            // console.log(values, 'hahaha')

            {
                updateEmployee({
                    id: values.id,
                    payload: {
                        ...values
                    }
                });
            }
        };


    //setup for table
        const columns = useMemo(() => [

        //setup for employees column
            {
                field:'employees',
                renderHeader: () => <strong>Employees</strong>,
                renderCell: ({ row }) => {
                    return <div>{row.name}</div>
                },
                flex: 1
            },
        //setup for actions column & adding a edit button to each row
            {
                field: 'Actions',
                align: 'right',
                headerAlign: 'right',
                renderHeader: () => <strong>Actions</strong>,
                renderCell: ({ row }) => (
                    <div>
                        <IconButton onClick= {(e) => openPopover(e, row)}>
                            <MoreVert />
                        </IconButton>
                    </div>
                ),
                flex: .2
            }

        ], []);

        // console.log(title)
        // console.log('here')

    return (
        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Grid item>
                    <Typography variant='h4' children={title_name}/>
                </Grid>

                <Grid item>
                    <Button
                    children='Assign'
                    variant='contained'
                    color='primary'
                    onClick={handleClickOpen}
                    />
                    <Dialog>
                        <DialogTitle content={`Assign New Employee`}/>
                    </Dialog>
                </Grid>
            </Grid>


            <DataGrid
                className={classes.dataGrid}
                //loading={isLoading}
                columns={columns}
                rows={titleEmployees || []}
                autoHeight
                disableSelectionOnClick
                hideFooterSelectedRowCount
            />

            <Menu
                id='actions'
                open={moreActions}
                anchorEl={actions}
                onClose={closePopover}
                onClickCapture={closePopover}
            >
                <MenuItem 
                    onClick={() => {
                        setInitialValues(rowSelected);
                        setEditModalOpen(true);
                    }}
                    style= {{width:'120px'}}>
                    Edit
                </MenuItem>
            </Menu>

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <AssignEmployeeForm setModalOpen={setModalOpen} employees={notTitleEmployees} onSubmit={onAssignSubmit} title_id={title_id}/>
                </DialogContent>
            </Dialog>

            <Dialog open={editModalOpen} onClose={() => setEditModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setEditModalOpen} initialValues={initialValues} onSubmit={onEditSubmit}/>
                </DialogContent>
            </Dialog>

            
            
        </div>
    )
};

export default TitleEmployees;